import { CONTROL, PayloadsType, TEST } from '../utils/types';

export const Name = 'map-lazy-load';

export const Payloads: PayloadsType = {
  [CONTROL]: true, // i.e display a placeholder
  [TEST]: false, // i.e display map without placeholder
};
